import { CanMatchFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export const AdminGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.ensureInitialized().then(() => {
    const ok = auth.isAuthenticated() && auth.isAdmin();
    if (ok) return true;
    return new RedirectCommand(router.createUrlTree(['/']));
  });
};
